/**
 * Funding type categories and items for discover-v2.
 * API expects funding types as option ids (e.g. PRE_SEED, SERIES_A).
 * Categories: Equity, Debt, Others.
 */
export const FUNDING_CATEGORIES = [
  {
    id: "Equity",
    label: "Equity",
    items: [
      { id: "PRE_SEED", label: "Pre-Seed" },
      { id: "SEED", label: "Seed" },
      { id: "SERIES_A", label: "Series A" },
      { id: "SERIES_B", label: "Series B" },
      { id: "SERIES_C", label: "Series C" },
      { id: "SERIES_D", label: "Series D" },
      { id: "SERIES_E", label: "Series E" },
      { id: "SERIES_F", label: "Series F" },
      { id: "SERIES_G", label: "Series G" },
      { id: "SERIES_H", label: "Series H" },
      { id: "SERIES_I", label: "Series I" },
      { id: "SERIES_J", label: "Series J" },
      { id: "VENTURE_ROUND", label: "Venture Round" },
      { id: "ANGEL", label: "Angel" },
      { id: "PRIVATE_EQUITY", label: "Private Equity" },
      { id: "EQUITY_CROWDFUNDING", label: "Equity Crowdfunding" },
      { id: "CORPORATE_ROUND", label: "Corporate Round" },
      { id: "SECONDARY_MARKET", label: "Secondary Market" },
      { id: "POST_IPO_EQUITY", label: "Post-IPO Equity" },
      { id: "POST_IPO_SECONDARY", label: "Post-IPO Secondary" },
      { id: "INITIAL_COIN_OFFERING", label: "Initial Coin Offering" },
      { id: "UNDISCLOSED", label: "Undisclosed" },
      { id: "SERIES_UNKNOWN", label: "Series Unknown" },
      { id: "FUNDING_ROUND", label: "Funding Round" }
    ]
  },
  {
    id: "Debt",
    label: "Debt",
    items: [
      { id: "DEBT_FINANCING", label: "Debt Financing" },
      { id: "CONVERTIBLE_NOTE", label: "Convertible Note" },
      { id: "POST_IPO_DEBT", label: "Post-IPO Debt" }
    ]
  },
  {
    id: "Others",
    label: "Others",
    items: [
      { id: "GRANT", label: "Grant" },
      { id: "PRODUCT_CROWDFUNDING", label: "Product Crowdfunding" },
      { id: "NON_EQUITY_ASSISTANCE", label: "Non-Equity Assistance" }
    ]
  }
];

/**
 * Returns options in the shape expected by CustomMultiSelect (accordion with submenu).
 */
export function buildFundingOptions() {
  return FUNDING_CATEGORIES.map(cat => ({
    id: cat.id,
    value: cat.label,
    show: true,
    showSubmenu: true,
    submenu: (cat.items || []).map(item => ({
      id: item.id,
      name: item.label,
      value: item.label,
      show: true
    }))
  }));
}
